import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BuildingIcon, ConstructionIcon, TrendingUpIcon, AlertCircleIcon, CheckCircleIcon } from 'lucide-react';
import PropertyCard from './common/PropertyCard';
import ProjectCard from './common/ProjectCard';
import { mockProperties, mockProjects } from '../data/mockData';
import { useFilter } from './context/FilterContext';
const Dashboard = () => {
  const {
    strategyFilter
  } = useFilter();
  const [filteredProperties, setFilteredProperties] = useState([]);
  // Filter properties based on global strategy filter
  useEffect(() => {
    if (strategyFilter === 'All') {
      setFilteredProperties(mockProperties.slice(0, 3));
    } else {
      const filtered = mockProperties.filter(prop => prop.investmentStrategy === strategyFilter).slice(0, 3);
      setFilteredProperties(filtered);
    }
  }, [strategyFilter]);
  // Get only the first 3 projects for the dashboard
  const recentProjects = mockProjects.slice(0, 3);
  return <div data-id="element-89">
      <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-90">Dashboard</h1>
      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-91">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-92">
          <div className="flex items-center" data-id="element-93">
            <div className="p-3 bg-blue-100 rounded-full" data-id="element-94">
              <BuildingIcon className="h-6 w-6 text-blue-600" data-id="element-95" />
            </div>
            <div className="ml-4" data-id="element-96">
              <p className="text-sm font-medium text-gray-500" data-id="element-97">
                Total Properties
              </p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-98">
                {strategyFilter === 'All' ? mockProperties.length : mockProperties.filter(p => p.investmentStrategy === strategyFilter).length}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-99">
          <div className="flex items-center" data-id="element-100">
            <div className="p-3 bg-green-100 rounded-full" data-id="element-101">
              <ConstructionIcon className="h-6 w-6 text-green-600" data-id="element-102" />
            </div>
            <div className="ml-4" data-id="element-103">
              <p className="text-sm font-medium text-gray-500" data-id="element-104">
                Active Projects
              </p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-105">
                {mockProjects.filter(p => p.status === 'In Progress').length}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-106">
          <div className="flex items-center" data-id="element-107">
            <div className="p-3 bg-yellow-100 rounded-full" data-id="element-108">
              <AlertCircleIcon className="h-6 w-6 text-yellow-600" data-id="element-109" />
            </div>
            <div className="ml-4" data-id="element-110">
              <p className="text-sm font-medium text-gray-500" data-id="element-111">
                Projects at Risk
              </p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-112">
                {mockProjects.filter(p => p.status === 'At Risk').length}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-113">
          <div className="flex items-center" data-id="element-114">
            <div className="p-3 bg-purple-100 rounded-full" data-id="element-115">
              <TrendingUpIcon className="h-6 w-6 text-purple-600" data-id="element-116" />
            </div>
            <div className="ml-4" data-id="element-117">
              <p className="text-sm font-medium text-gray-500" data-id="element-118">Total Value</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-119">$24.5M</p>
            </div>
          </div>
        </div>
      </div>
      {/* Recent Properties */}
      <div className="mb-8" data-id="element-120">
        <div className="flex justify-between items-center mb-4" data-id="element-121">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-122">
            {strategyFilter === 'All' ? 'Recent Properties' : strategyFilter === 'Long-Term Hold' ? 'Recent Hold Properties' : 'Recent Flip Properties'}
          </h2>
          <Link to="/properties" className="text-blue-600 hover:text-blue-800 font-medium" data-id="element-123">
            View All
          </Link>
        </div>
        {filteredProperties.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
            {filteredProperties.map(property => <PropertyCard key={property.id} property={property} data-id="element-125" />)}
          </div> : <div className="text-center py-8 bg-gray-50 border border-gray-200 rounded-lg" data-id="element-126">
            <p className="text-gray-500" data-id="element-127">
              No properties found with the selected strategy.
            </p>
          </div>}
      </div>
      {/* Recent Projects */}
      <div data-id="element-128">
        <div className="flex justify-between items-center mb-4" data-id="element-129">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-130">Recent Projects</h2>
          <Link to="/projects" className="text-blue-600 hover:text-blue-800 font-medium" data-id="element-131">
            View All
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-132">
          {recentProjects.map(project => <ProjectCard key={project.id} project={project} data-id="element-133" />)}
        </div>
      </div>
    </div>;
};
export default Dashboard;